export const validatePin = (pin: string[]): boolean => pin.length === 4 && pin.every(char => /^\d+$/.test(char));